import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Weather.css";

import SearchBar from "./SearchBar";
import CurrentWeather from "./CurrentWeather";
import Forecast from "./Forecast";

const API_KEY = "470c09f57bd9o90adc47e3t0cd74b0fc";

export default function App() {
  const [city, setCity] = useState("London");
  const [weather, setWeather] = useState(null);
  const [forecast, setForecast] = useState(null);
  const [unit, setUnit] = useState("metric");

  useEffect(() => {
    fetchWeather(city);
  }, [city, unit]);

  const fetchWeather = async (cityName) => {
    try {
      const weatherRes = await axios.get(
        `https://api.shecodes.io/weather/v1/current?query=${cityName}&key=${API_KEY}`,
      );

      const forecastRes = await axios.get(
        `https://api.shecodes.io/weather/v1/forecast?query=${cityName}&key=${API_KEY}`,
      );

      setWeather(weatherRes.data);
      setForecast(forecastRes.data);
    } catch (err) {
      console.error("API error:", err);
    }
  };

  return (
    <div className="app-container">
      <div className="weather-card">
        <SearchBar onSearch={setCity} />
        <CurrentWeather data={weather} unit={unit} setUnit={setUnit} />
        <Forecast forecast={forecast} />
      </div>
    </div>
  );
}
